import React from "react";
import { useParams } from "react-router";

import classNames from "classnames";
import { Table } from "react-bootstrap";
import invariant from "tiny-invariant";

import { useEjectionReportsContext } from "../contexts/EjectionReports";
import { getNameOfEjected } from "../lib/getNameOfEjected";

import { store } from "../../../..";
import {
    globalActions,
    selectAllSites,
} from "../../../../features/global/globalSlice";
import { useAppSelector } from "../../../../hooks/reduxHooks";
import { defaultDateFormat } from "../../../../lib/utils";
import { Link } from "react-router-dom";

export const loader = async () => {
    const { settings, sites, umpires } = store.getState().global;
    const promises = [];
    !settings.length &&
        promises.push(store.dispatch(globalActions.getSettings()));
    !sites.length && promises.push(store.dispatch(globalActions.getSites()));
    !umpires.length &&
        promises.push(store.dispatch(globalActions.getUmpires()));

    await Promise.all([promises]);

    return null;
};

const Report = (): React.JSX.Element => {
    const { gameId } = useParams();
    const sites = useAppSelector(selectAllSites);
    const { reports } = useEjectionReportsContext();
    const report = reports.find(r => gameId && r.id === parseInt(gameId));
    invariant(report);

    return (
        <>
            <Link to="/admin/ejection-reports">View All Ejections</Link>
            <Table className={classNames("ejectionReport")}>
                <tbody>
                    <tr>
                        <th scope="row">Date</th>
                        <td>
                            {defaultDateFormat.format(new Date(report.date))}
                        </td>
                    </tr>
                    <tr>
                        <th scope="row">Site</th>
                        <td>
                            {sites.find(s => s.id === report.site)?.displayName}
                        </td>
                    </tr>
                    <tr>
                        <th scope="row">Game</th>
                        <td>
                            {`(${report.ageLevel.ageLevel}) ${report.visitor.name} @ ${report.home.name}`}
                        </td>
                    </tr>
                    <tr>
                        <th scope="row">Umpire</th>
                        <td>
                            {
                                report.umpires?.find(
                                    u => u.id === report.userId,
                                )?.name
                            }
                        </td>
                    </tr>
                    <tr>
                        <th scope="row">Name of Ejected Person</th>
                        <td>{getNameOfEjected(report)}</td>
                    </tr>
                    <tr>
                        <th scope="row">Report</th>
                        <td>{report.report}</td>
                    </tr>
                </tbody>
            </Table>
        </>
    );
};

export default Report;
